import {Component, Input, OnInit} from '@angular/core';
import {PlanModelService} from '../../common/service/plan-model.service';
import {NgClass} from '@angular/common';
import {ControlContainer, FormsModule, NgForm} from '@angular/forms';
import {NlrHasPermissionsPipe} from '../../common/pipe/nlr-has-permissions.pipe';
import {MaxLengthInputLimitDirective} from '../../common/directive/max-length-input-limit.directive';
import {PermissionsService} from '../../common/service/permissions.service';

@Component({
    selector: 'nlr-field-record',
    imports: [NgClass, FormsModule, NlrHasPermissionsPipe, MaxLengthInputLimitDirective],
    templateUrl: './field-record.component.html',
    styleUrl: './field-record.component.scss',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class FieldRecordComponent implements OnInit {
    @Input() submitted: boolean;
    get readonly() {
        return this.planModelService.readonly;
    }

    editViewInformationPermissions = ['EDIT_INFORMATION', 'VIEW_INFORMATION'];

    constructor(
        private permissionsService: PermissionsService,
        private planModelService: PlanModelService
    ) {}

    ngOnInit(): void {
        if (this.planModelService.getModel().fieldRecords && this.planModelService.getModel().fieldRecords.length === 0) {
            this.addFieldRecord();
        }
    }

    title = 'Field record/s';

    getModel() {
        return this.planModelService.getModel();
    }

    addFieldRecord() {
        this.planModelService.getModel().fieldRecords.push({fieldRecordNumber: ''});
    }

    allowAdditionalFieldBooks() {
        return (
            this.planModelService.getModel().fieldRecords.filter(row => row.fieldRecordNumber == '' || row.fieldRecordNumber == undefined).length == 0
        );
    }

    isFieldRecordDupicate(data, i) {
        const index = this.planModelService.getModel().fieldRecords.findIndex(row => row != data && row.fieldRecordNumber == data.fieldRecordNumber);
        return index > -1 && index < i;
    }

    removeFieldRecord(i: number) {
        this.planModelService.getModel().fieldRecords.splice(i, 1);
    }

    isRequired = function () {
        const planModel = this.planModelService.getModel();
        return planModel && planModel.surveyMethod && planModel.surveyMethod.fieldRecordRequired === 'MANDATORY';
    };

    hasMandatoryError(record: any) {
        return this.isRequired() && record.invalid && this.planModelService.validated;
    }

    onFieldRecordChange(event: any, index: number, maxLength: number) {
        const input = event.target as HTMLInputElement;
        if (input.value.length > maxLength) {
            input.value = this.getModel().fieldRecords[index].fieldRecordNumber || '';
        } else {
            this.getModel().fieldRecords[index].fieldRecordNumber = input.value;
        }
    }

    isDisabled() {
        return this.planModelService.readonly || this.permissionsService.isDisabledByPermissions(this.editViewInformationPermissions);
    }
}
